import React from 'react'

// Uygulama geneli hata sınırı — beyaz ekran yerine KENDİ KENDİNE İYİLEŞME.
// Kademeli kurtarma (30 sn içinde tekrar çökerse bir üst adıma geçer):
//   1) İlk çökme  → sayfayı yenile (deploy sonrası taze chunk'lar gelir).
//   2) Tekrar     → birikmiş ARAYÜZ durumunu temizle (eski/bozuk localStorage filtre, kolon
//                   ayarı, favori vs. — auth KORUNUR) + yenile. Eski durumdan gelen çökmeler biter.
//   3) Yine       → gerçek hata; kısa 'Yenile' ekranı (döngüye girmez).
// Böylece kullanıcı normal sayfa görür; dead-end/beyaz ekran kalmaz.
const KEY = 'vertex_recover_step'

// Temizlikten MUAF anahtarlar. Kurtarma, BOZUK GÖRÜNÜM DURUMUNU (filtre, kolon genişliği,
// sıralama) atmak içindir; kullanıcının kendi girdiği içeriği değil. Sol menü favorileri
// kullanıcının elle sabitlediği sayfalardır ve YALNIZ tarayıcıda durur — silinince geri
// getirilemez. 20.08.2026'da sohbet ekranındaki bir çökme ikinci adıma kadar tırmandı ve
// herkesin favorileri bu satırda silindi. Okuma zaten güvenli (try/catch + string filtresi),
// yani korumak çökme döngüsü riski yaratmaz.
const KEEP_KEYS = /^(auth_state|vertex\.sidebar\.favorites)$/

function clearUiState() {
  // VERTEX'in kaydettiği arayüz durumları — auth, firma seçimi ve favoriler HARİÇ.
  try {
    const keep = KEEP_KEYS
    const drop = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && !keep.test(k)) drop.push(k)
    }
    drop.forEach((k) => { try { localStorage.removeItem(k) } catch { /* noop */ } })
    // sessionStorage sayfa-filtreleri (auth ve firma korunur)
    const ss = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (k && k !== 'auth_state' && k !== 'app_activeCompany' && !k.startsWith('vertex_')) ss.push(k)
    }
    ss.forEach((k) => { try { sessionStorage.removeItem(k) } catch { /* noop */ } })
  } catch { /* noop */ }
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { crashed: false, showFallback: false, err: '', stack: '' }
  }

  static getDerivedStateFromError() {
    return { crashed: true }
  }

  componentDidCatch(error, info) {
    // Hatayı sunucuya raporla (teşhis — reprodüksiyon yapılamayan çökmeler için). Best-effort.
    try {
      let who = ''
      try { who = (JSON.parse(sessionStorage.getItem('auth_state') || '{}').user || {}).username || '' } catch { /* noop */ }
      const build = (document.querySelector('script[src*="/assets/index-"]')?.getAttribute('src') || '').match(/index-[^./]+/)?.[0] || ''
      fetch('/api/v1/client-log/error', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({
          url: location.pathname + location.search,
          message: String(error?.message || error).slice(0, 1000),
          stack: String((error?.stack || '') + '\n---\n' + (info?.componentStack || '')).slice(0, 4000),
          user: who, build, ua: navigator.userAgent,
        }),
      }).catch(() => {})
    } catch { /* noop */ }

    let step = 0
    let last = 0
    try {
      const raw = JSON.parse(sessionStorage.getItem(KEY) || '{}')
      step = raw.step || 0
      last = raw.at || 0
    } catch { /* noop */ }
    const now = Date.now()
    // 30 sn geçtiyse sıfırla — geçici/tek seferlik hataları döngü sayma
    if (now - last > 30000) step = 0
    // eslint-disable-next-line no-console
    console.warn('AppErrorBoundary: render hatası (adım ' + step + ')', error?.message || error)

    if (step === 0) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ step: 1, at: now })) } catch { /* noop */ }
      window.location.reload()
    } else if (step === 1) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ step: 2, at: now })) } catch { /* noop */ }
      clearUiState()  // eski/bozuk arayüz durumundan gelen çökmeyi temizle
      window.location.reload()
    } else {
      // Kurtarma başarısız → gerçek hata; kısa ekran + guard sıfırla (kullanıcı Yenile'ye basınca 1'den başlar)
      try { sessionStorage.removeItem(KEY) } catch { /* noop */ }
      // Hatayı EKRANDA da göster. Bilgisiz "Sayfa açılamadı" ekranı teşhisi
      // imkânsız kılıyordu: kullanıcı DevTools açmadan hiçbir şey iletemiyor,
      // sunucuya düşen kayıt da (rpt_client_error) okunabilir değil.
      this.setState({
        showFallback: true,
        err: String(error?.message || error).slice(0, 500),
        stack: String((error?.stack || '') + '\n' + (info?.componentStack || '')).slice(0, 1500),
      })
    }
  }

  render() {
    if (this.state.showFallback) {
      return (
        <div style={{
          minHeight: '60vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 12,
          fontFamily: 'Figtree, system-ui, sans-serif', color: '#374151', padding: 24, textAlign: 'center',
        }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>Sayfa açılamadı</div>
          <div style={{ fontSize: 13, color: '#6b7280' }}>Yeniden denemek için butona bas.</div>
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '8px 16px', fontSize: 13, fontWeight: 500,
                background: '#6C5CE7', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer',
              }}
            >
              Yenile
            </button>
            <button
              onClick={() => { window.location.href = '/dashboard' }}
              style={{
                padding: '8px 16px', fontSize: 13, fontWeight: 500,
                background: '#fff', color: '#374151', border: '1px solid #d1d5db',
                borderRadius: 8, cursor: 'pointer',
              }}
            >
              Ana sayfaya dön
            </button>
          </div>

          {/* Hatanın kendisi — teşhis için. Kullanıcı bunu kopyalayıp iletebilir. */}
          {this.state.err && (
            <details style={{ marginTop: 12, maxWidth: 720, width: '100%', textAlign: 'left' }}>
              <summary style={{ fontSize: 12, color: '#6b7280', cursor: 'pointer' }}>
                Teknik detay (geliştiriciye iletmek için)
              </summary>
              <div style={{
                marginTop: 8, padding: 10, background: '#f9fafb', border: '1px solid #e5e7eb',
                borderRadius: 8, fontSize: 11, fontFamily: 'ui-monospace, Menlo, monospace',
                color: '#b91c1c', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                maxHeight: 260, overflow: 'auto',
              }}>
                {this.state.err}
                {this.state.stack ? `\n\n${this.state.stack}` : ''}
              </div>
              <button
                onClick={() => {
                  try {
                    navigator.clipboard.writeText(
                      `${location.pathname}\n${this.state.err}\n\n${this.state.stack}`,
                    )
                  } catch { /* noop */ }
                }}
                style={{
                  marginTop: 6, padding: '5px 10px', fontSize: 11,
                  background: '#fff', color: '#374151', border: '1px solid #d1d5db',
                  borderRadius: 6, cursor: 'pointer',
                }}
              >
                Panoya kopyala
              </button>
            </details>
          )}
        </div>
      )
    }
    // crashed ama fallback değil → reload/clear tetiklendi; boş bırak (anlık, sayfa yenileniyor)
    if (this.state.crashed) return null
    return this.props.children
  }
}
